// console.log('resources/assets/js/bootstrap.js');
/**
 * This bootstrap file is used for both frontend and backend
 */

/**
 * Font Awesome 5
 */
import fontawesome from '@fortawesome/fontawesome';
import brands from '@fortawesome/fontawesome-free-brands';
import regular from '@fortawesome/fontawesome-free-regular';
import solid from '@fortawesome/fontawesome-free-solid';
import Popper from 'popper.js/dist/umd/popper.js';

// import { LoadingBar } from 'quasar';
import './mixins/axios-config.js';

// import 'animate.css';
import 'animate.css/animate.compat.css';

// console.log('LoadingBar: ', LoadingBar);
window.quasarConfig = {
	loadingBar: {
		color: 'teal',
		size: '10px',
		position: 'bottom'
	}
};

// LoadingBar.setDefaults({
// 	color: 'purple',
// 	size: '15px',
// 	position: 'bottom'
// });

window._ = require('lodash');
window.swal = require('sweetalert2');

fontawesome.library.add(solid);
fontawesome.library.add(regular);
fontawesome.library.add(brands);

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
	window.$ = window.jQuery = require('jquery');

	// Required for BS4
	window.Tether = require('tether');
	window.Popper = Popper;

	require('bootstrap');
} catch (e) {
	console.log(e);
}
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
